import { getSignInType } from './states';

export const services = {
  getSignInType: getSignInType,
};
